import controller from './box-post-by-category.controller';
import templateDefault from './templates/box-post-t1-view.html';

let BoxPostByCategoryComponent = {
    template: templateDefault,
    controller,
    bindings: {
        shCtrl: '<',
        postByCategory: '<',

    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
   return templateDefault;
}

export default BoxPostByCategoryComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/category/box-post-by-category/box-post-by-category.component.js